"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mostrarStream = exports.tomarFoto = exports.iniciarCamara = exports.detenerCamara = exports.setStream = exports.getStream = exports.getCameraStream = exports.getMediaStream = exports.validarSoporteCamara = void 0;
const errors_1 = require("./errors");
let stream = null;
const imageQuality = 1; // 0.1 = 10% de calidad, 1 = 100% de calidad
const aspectRatioDocumento = 85.6 / 53.98;
const esMovil = () => {
    return /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent);
};
const crearConstraintsTrasera = () => [
    {
        nombre: '1440p trasera',
        constraints: {
            video: {
                width: { min: 2560, ideal: 2560 },
                height: { min: 1440, ideal: 1440 },
                aspectRatio: { ideal: aspectRatioDocumento },
                frameRate: { ideal: 30 },
                facingMode: { exact: 'environment' }
            },
            audio: false
        }
    },
    {
        nombre: 'Full HD trasera',
        constraints: {
            video: {
                width: { min: 1920, ideal: 1920 },
                height: { min: 1080, ideal: 1080 },
                aspectRatio: { ideal: aspectRatioDocumento },
                frameRate: { ideal: 30 },
                facingMode: { exact: 'environment' }
            },
            audio: false
        }
    },
    {
        nombre: 'HD trasera',
        constraints: {
            video: {
                width: { min: 1280, ideal: 1280 },
                height: { min: 720, ideal: 720 },
                aspectRatio: { ideal: aspectRatioDocumento },
                frameRate: { ideal: 30 },
                facingMode: { exact: 'environment' }
            },
            audio: false
        }
    },
    {
        nombre: 'VGA trasera',
        constraints: {
            video: {
                width: { min: 640, ideal: 640 },
                height: { min: 480, ideal: 480 },
                aspectRatio: { ideal: aspectRatioDocumento },
                frameRate: { ideal: 30 },
                facingMode: { exact: 'environment' }
            },
            audio: false
        }
    }
];
const crearConstraintsDesktop = () => [
    {
        nombre: '1440p cámara disponible',
        constraints: {
            video: {
                width: { min: 2560, ideal: 2560 },
                height: { min: 1440, ideal: 1440 },
                aspectRatio: { ideal: aspectRatioDocumento },
                frameRate: { ideal: 30 }
            },
            audio: false
        }
    },
    {
        nombre: 'Full HD cámara disponible',
        constraints: {
            video: {
                width: { min: 1920, ideal: 1920 },
                height: { min: 1080, ideal: 1080 },
                aspectRatio: { ideal: aspectRatioDocumento },
                frameRate: { ideal: 30 }
            },
            audio: false
        }
    },
    {
        nombre: 'HD cámara disponible',
        constraints: {
            video: {
                width: { min: 1280, ideal: 1280 },
                height: { min: 720, ideal: 720 },
                aspectRatio: { ideal: aspectRatioDocumento },
                frameRate: { ideal: 30 }
            },
            audio: false
        }
    },
    {
        nombre: 'VGA cámara disponible',
        constraints: {
            video: {
                width: { min: 640, ideal: 640 },
                height: { min: 480, ideal: 480 },
                aspectRatio: { ideal: aspectRatioDocumento },
                frameRate: { ideal: 30 }
            },
            audio: false
        }
    },
    {
        nombre: 'Default cámara disponible',
        constraints: {
            video: true,
            audio: false
        }
    }
];
const validarSoporteCamara = () => {
    return ('mediaDevices' in navigator &&
        'getUserMedia' in navigator.mediaDevices);
};
exports.validarSoporteCamara = validarSoporteCamara;
const detenerTracks = (mediaStream) => {
    if (!mediaStream) {
        return;
    }
    mediaStream.getTracks().forEach((track) => track.stop());
};
const obtenerCamaraTraseraPorDeviceId = () => __awaiter(void 0, void 0, void 0, function* () {
    let streamTemporal = null;
    try {
        // Se solicita primero cualquier cámara para desbloquear labels en algunos navegadores
        streamTemporal = yield navigator.mediaDevices.getUserMedia({
            video: true,
            audio: false
        });
        const devices = yield navigator.mediaDevices.enumerateDevices();
        const videoInputs = devices.filter((device) => device.kind === 'videoinput');
        if (!videoInputs.length) {
            return null;
        }
        // Intenta localizar la trasera por label
        const camaraTrasera = videoInputs.find((device) => /back|rear|environment|trasera|traseira/i.test(device.label)) ||
            // En muchos móviles la última suele ser la trasera principal
            videoInputs[videoInputs.length - 1];
        if (!(camaraTrasera === null || camaraTrasera === void 0 ? void 0 : camaraTrasera.deviceId)) {
            return null;
        }
        detenerTracks(streamTemporal);
        streamTemporal = null;
        const listaPorDeviceId = [
            {
                nombre: '1440p trasera por deviceId',
                constraints: {
                    video: {
                        width: { min: 2560, ideal: 2560 },
                        height: { min: 1440, ideal: 1440 },
                        aspectRatio: { ideal: aspectRatioDocumento },
                        frameRate: { ideal: 30 },
                        deviceId: { exact: camaraTrasera.deviceId }
                    },
                    audio: false
                }
            },
            {
                nombre: 'Full HD trasera por deviceId',
                constraints: {
                    video: {
                        width: { min: 1920, ideal: 1920 },
                        height: { min: 1080, ideal: 1080 },
                        aspectRatio: { ideal: aspectRatioDocumento },
                        frameRate: { ideal: 30 },
                        deviceId: { exact: camaraTrasera.deviceId }
                    },
                    audio: false
                }
            },
            {
                nombre: 'HD trasera por deviceId',
                constraints: {
                    video: {
                        width: { min: 1280, ideal: 1280 },
                        height: { min: 720, ideal: 720 },
                        aspectRatio: { ideal: aspectRatioDocumento },
                        frameRate: { ideal: 30 },
                        deviceId: { exact: camaraTrasera.deviceId }
                    },
                    audio: false
                }
            },
            {
                nombre: 'VGA trasera por deviceId',
                constraints: {
                    video: {
                        width: { min: 640, ideal: 640 },
                        height: { min: 480, ideal: 480 },
                        aspectRatio: { ideal: aspectRatioDocumento },
                        frameRate: { ideal: 30 },
                        deviceId: { exact: camaraTrasera.deviceId }
                    },
                    audio: false
                }
            }
        ];
        for (const constraint of listaPorDeviceId) {
            try {
                return yield navigator.mediaDevices.getUserMedia(constraint.constraints);
            }
            catch (error) {
                if (error.name !== 'OverconstrainedError' &&
                    error.name !== 'NotFoundError') {
                    throw error;
                }
            }
        }
        return null;
    }
    finally {
        detenerTracks(streamTemporal);
    }
});
const getMediaStream = () => __awaiter(void 0, void 0, void 0, function* () {
    const esDispositivoMovil = esMovil();
    if (esDispositivoMovil) {
        const listaConstraintsMovil = crearConstraintsTrasera();
        for (const constraint of listaConstraintsMovil) {
            try {
                return yield navigator.mediaDevices.getUserMedia(constraint.constraints);
            }
            catch (error) {
                if (error.name !== 'OverconstrainedError' &&
                    error.name !== 'NotFoundError') {
                    throw error;
                }
            }
        }
        // Fallback más robusto para ciertos Android/Samsung
        const streamTraseroPorDeviceId = yield obtenerCamaraTraseraPorDeviceId();
        if (streamTraseroPorDeviceId) {
            return streamTraseroPorDeviceId;
        }
        // Último fallback en móvil: cualquier cámara, para no romper la experiencia
        return yield navigator.mediaDevices.getUserMedia({
            video: true,
            audio: false
        });
    }
    const listaConstraintsDesktop = crearConstraintsDesktop();
    for (const constraint of listaConstraintsDesktop) {
        try {
            return yield navigator.mediaDevices.getUserMedia(constraint.constraints);
        }
        catch (error) {
            if (error.name !== 'OverconstrainedError') {
                throw error;
            }
        }
    }
    throw new errors_1.CameraError('No se pudo acceder a la cámara.');
});
exports.getMediaStream = getMediaStream;
const getCameraStream = () => __awaiter(void 0, void 0, void 0, function* () {
    if (!(0, exports.validarSoporteCamara)()) {
        throw new Error('Este navegador no soporta getUserMedia.');
    }
    try {
        return yield (0, exports.getMediaStream)();
    }
    catch (error) {
        if (error.name === 'NotAllowedError') {
            throw new errors_1.CameraPermissionError('No se ha otorgado permiso para acceder a la cámara.');
        }
        if (error.name === 'NotReadableError') {
            throw new errors_1.CameraUnavailableError('La cámara está siendo utilizada por otra aplicación.');
        }
        throw error;
    }
});
exports.getCameraStream = getCameraStream;
const getStream = () => stream;
exports.getStream = getStream;
const setStream = (newStream) => {
    if (newStream === null || newStream instanceof MediaStream) {
        stream = newStream;
    }
    else {
        throw new TypeError('El stream no es una instancia de MediaStream.');
    }
};
exports.setStream = setStream;
const detenerCamara = (videoElement) => __awaiter(void 0, void 0, void 0, function* () {
    const currentStream = (0, exports.getStream)();
    if (currentStream) {
        const tracks = currentStream.getTracks();
        tracks.forEach((track) => track.stop());
        videoElement.srcObject = null;
        (0, exports.setStream)(null);
        console.log('La cámara se ha detenido correctamente.');
    }
});
exports.detenerCamara = detenerCamara;
const iniciarCamara = (videoElement) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const stream = yield (0, exports.getCameraStream)();
        (0, exports.setStream)(stream);
        videoElement.srcObject = stream;
        yield videoElement.play();
        console.log('La cámara se ha iniciado correctamente.');
    }
    catch (error) {
        console.error('Error al iniciar la cámara:', error);
        if (error instanceof errors_1.CameraPermissionError) {
            throw new errors_1.CameraPermissionError('No se ha otorgado permiso para acceder a la cámara.');
        }
        if (error instanceof errors_1.CameraUnavailableError) {
            throw new errors_1.CameraUnavailableError('La cámara está siendo utilizada por otra aplicación.');
        }
        throw new errors_1.CameraError('No se ha podido iniciar la cámara.');
    }
});
exports.iniciarCamara = iniciarCamara;
const tomarFoto = (videoElement) => __awaiter(void 0, void 0, void 0, function* () {
    const stream = (0, exports.getStream)();
    if (!stream) {
        console.warn('La cámara no está iniciada. Imposible tomar una foto.');
        return;
    }
    const canvas = document.createElement('canvas');
    const anchoRecorte = videoElement.videoWidth;
    const altoRecorte = Math.round(anchoRecorte / aspectRatioDocumento);
    canvas.width = anchoRecorte;
    canvas.height = altoRecorte;
    const context = canvas.getContext('2d');
    if (!context) {
        throw new Error('No se ha podido obtener el contexto del canvas.');
    }
    const offsetX = 0;
    const offsetY = Math.round((videoElement.videoHeight - altoRecorte) / 2);
    context.drawImage(videoElement, offsetX, offsetY, anchoRecorte, altoRecorte, 0, 0, anchoRecorte, altoRecorte);
    const blob = yield new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', imageQuality));
    if (!blob) {
        throw new Error('No se ha podido crear el blob de la foto.');
    }
    const fotoURL = canvas.toDataURL('image/jpeg', imageQuality);
    return {
        fotoURL,
        blob
    };
});
exports.tomarFoto = tomarFoto;
const mostrarStream = (videoElement) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const stream = (0, exports.getStream)();
        if (!stream) {
            console.warn('La cámara no está iniciada. Imposible mostrar el stream.');
            return;
        }
        videoElement.srcObject = stream;
        yield videoElement.play();
        console.log('Stream mostrado correctamente.');
    }
    catch (error) {
        console.error('Error al mostrar el stream:', error);
        throw error;
    }
});
exports.mostrarStream = mostrarStream;
